import type { BridgeMcpToolDefinition } from '../../bridge-mcp-tool-types.js';
import { GET_INTEGRATION_CONTENT_TOOL } from './tool-names.js';

const SESSION_ID_SCHEMA = {
  type: 'string',
  description:
    'Id of the current session. Required on every tool call so the workspace integration credentials can be resolved.',
};

export const INTEGRATION_CONTENT_MCP_TOOL_DEFINITIONS: BridgeMcpToolDefinition[] = [
  {
    name: GET_INTEGRATION_CONTENT_TOOL,
    description:
      'Fetch the full content of a supported external integration link (Linear, GitHub, Jira, Notion, Slack thread, Zoom meeting, Asana). Requires sessionId and url. By default, links the URL as this session external ticket when the session has none yet. Pass associateAsSessionTicket: false to fetch content only (e.g. additional context links). Returns an error when the URL is unsupported, the integration is not connected, or content is temporarily unavailable (retry may succeed).',
    inputSchema: {
      type: 'object',
      properties: {
        sessionId: SESSION_ID_SCHEMA,
        url: { type: 'string', description: 'External integration URL to fetch' },
        associateAsSessionTicket: {
          type: 'boolean',
          description:
            'Defaults to true. When true and the session has no linked external ticket yet, links this URL as the session external ticket. Pass false when fetching additional links for context only.',
        },
      },
      required: ['sessionId', 'url'],
      additionalProperties: false,
    },
  },
];
